export default {
  userTypeFilter (val) {
    const obj = {
      0: '管理员',
      1: '普通用户'
    }
    return obj[val]
  }
}



// WEBPACK FOOTER //
// ./src/filters/common.js